module.exports = __webpack_public_path__ + "img/circle-table-8.87053b3d.png";